import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'

const PasswordResetStep2UI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    email, onEmailChange, emailError, setEmailError,
    resetCode, onResetCodeChange, resetCodeError, setResetCodeError,
    newPassword, onNewPasswordChange, newPasswordError, setNewPasswordError
  }) =>
  <React.Fragment>
    <CardUI context={context}>
      <FormSF context={context} messageList={messageList} buttonMessageKey='c_reset_password'
          onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
          busy={submitted}>
        <InputTextSF type='text' name='resetCode' required={true} maxLength={10}
          messageList={messageList} labelKey='c_password_reset_code'
          value={resetCode} onChange={onResetCodeChange}
          error={resetCodeError} setError={setResetCodeError}
          autoFocus={true}
        />
        <InputTextSF type='text' name='email' required={true} maxLength={64}
          messageList={messageList} labelKey='c_email'
          value={email} onChange={onEmailChange}
          error={emailError} setError={setEmailError}
        />
        <InputTextSF type='password' name='newPassword' required={true} maxLength={40}
          messageList={messageList} labelKey='c_new_password'
          value={newPassword} onChange={onNewPasswordChange}
          error={newPasswordError} setError={setNewPasswordError}
        />
      </FormSF>
    </CardUI>

    <div className='g_m_top_100'>
      <ButtonLinkUI context={context} messageList={messageList} labelKey='c_re_passwd_reset'
        to={`/pub/password-help?identity=${email}`}
        transparent={true}
      />
    </div>
  </React.Fragment>

export default PasswordResetStep2UI
